import React from "react";

class SectionNewOpportunities extends React.Component{
    render(){
        return(
            <section
            className="elementor-section elementor-top-section elementor-element elementor-element-462b1e22 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="462b1e22"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-default">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-44560f57"
                data-id="44560f57"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-20825d1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="20825d1"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-default">
                      <div
                        className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-f7c06ec"
                        data-id="f7c06ec"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-290b3fda elementor-widget elementor-widget-heading"
                            data-id="290b3fda"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <h6 className="elementor-heading-title elementor-size-default">
                                NOVAS OPORTUNIDADES
                              </h6>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-4973da90 elementor-widget elementor-widget-heading"
                            data-id="4973da90"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                Universo de Negócios!
                              </h2>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-4818817 elementor-widget elementor-widget-text-editor"
                            data-id="4818817"
                            data-element_type="widget"
                            data-widget_type="text-editor.default"
                          >
                            <div className="elementor-widget-container">
                              <p>
                                Em breve, novidades exclusivas em áreas
                                estratégicas estarão ao seu alcance, trazendo
                                soluções inovadoras para impulsionar seu
                                sucesso
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>
        );
    }
}

export default SectionNewOpportunities;